import NextImage from "next/image";
import React from "react";

import { horizontalProductCardImageVariants } from "./HorizontalProductCard.css";
import type { ProductCardDataType } from "./types";

type Props = {
  altOverride?: string;
  product: Pick<ProductCardDataType, "image" | "brandName">;
  onClick?: () => void;
};

// Helper function to replace getStaticFile
const getPlaceholderImage = () => "/images/placeholder.svg";

export const BP_PRODUCT_CARD_IMAGE_QUALITY = 85;

export const HorizontalProductCardImage: React.FC<Props> = ({
  altOverride,
  product,
  onClick
}) => {
  const handleClick = onClick
    ? (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }
    : undefined;

  const propOverrides = {
    height: undefined as number | undefined,
    width: undefined as number | undefined,
    style: {},
    sizes: ""
  };

  propOverrides.style = {
    height: "auto",
    width: "auto",
    objectFit: "cover" as const,
    maxHeight: "7rem",
    minHeight: "5rem"
  };

  propOverrides.sizes =
    "(max-width: 374px) 100vw, (max-width: 768px) 50vw, (max-width: 1440px) 33vw, 20vw";

  return (
    <div
      className={horizontalProductCardImageVariants.square}
      onClick={handleClick}
    >
      <NextImage
        src={product.image.src || getPlaceholderImage()}
        alt={altOverride ?? product.image.alt ?? product.brandName ?? ""}
        placeholder="blur"
        blurDataURL={getPlaceholderImage()}
        fill
        style={{
          objectFit: "cover"
        }}
        sizes={propOverrides.sizes}
        quality={BP_PRODUCT_CARD_IMAGE_QUALITY}
      />
    </div>
  );
};
